import React from 'react';
import CountUp from 'react-countup';
import { useSocket } from '../../hooks/useSocket';

export const OperatorStats = () => {
  const {
    deviceAmount,
    routerAmount,
    todayDnsRecordsAmount,
    todayThreatsAmount,
  } = useSocket();

  return (
    <div>
      <h2>📊 Operator Stats</h2>
      <ul>
        <li>
          Devices:{' '}
          <CountUp end={deviceAmount} duration={2} separator="," />
        </li>
        <li>
          Routers:{' '}
          <CountUp end={routerAmount} duration={2} separator="," />
        </li>
        <li>
          DNS Records Today:{' '}
          <CountUp end={todayDnsRecordsAmount} duration={2} separator="," />
        </li>
        <li>
          Threats Today:{' '}
          <CountUp end={todayThreatsAmount} duration={2} separator="," />
        </li>
      </ul>
      <p style={{ fontStyle: 'italic', color: '#888' }}>
        * Stats persist and reflect the highest values until updated.
      </p>
    </div>
  );
};
